<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col class="animated fadeIn" cols="12">
        <reporte-compras-nuevo />
        <c-paginate table-uri="paginate/table/reportes_compras" caption="Reportes de compras"  :fields="fields" edit-name="Detalle de reporte de compras">  </c-paginate>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import axios from 'axios'
  import _ from 'lodash'
  import reporteComprasNuevo from './reporteComprasNuevo.vue'

  export default {
    name: 'PedidosIndex',
    components: {reporteComprasNuevo},
    data: () => {
      return {
        fields: [{
            key: 'fecha_inicio',
            label: 'Inicio'
          },
          {
            key: 'fecha_fin',
            label: 'Cierre'
          },
          {
            key: 'estatus',
            label: 'Estatus'
          },
          {
            key: 'created',
            label: 'Fecha y hora de creación'
          },
          {
            key: '_',
            label: ''
          }
        ]
      }
    }
  }

</script>
